import {
  AfterViewInit,
  Component,
  ElementRef,
  ViewChild,
  inject,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  PasswordChangeResult,
  passwordRuleState,
  validatePasswordChange,
} from '../password-dialog/password-dialog.validation';

@Component({
  selector: 'gep-change-password',
  imports: [ReactiveFormsModule],
  templateUrl: './change-password.component.html',
  styleUrl: '../password-dialog/password-dialog.css',
})
export class ChangePasswordComponent implements AfterViewInit {
  private readonly activeModal = inject(NgbActiveModal);

  @ViewChild('currentPasswordInput')
  currentPasswordInput?: ElementRef<HTMLInputElement>;

  readonly senhaAtual = new FormControl('', { nonNullable: true });
  readonly novaSenha = new FormControl('', { nonNullable: true });
  readonly repetirSenha = new FormControl('', { nonNullable: true });

  readonly visible = {
    atual: false,
    nova: false,
    repetir: false,
  };

  validationMessage = '';

  ngAfterViewInit(): void {
    this.currentPasswordInput?.nativeElement.focus();
  }

  rules() {
    return passwordRuleState(this.novaSenha.value, this.repetirSenha.value);
  }

  ruleIcon(state: boolean | null): string {
    if (state === true) {
      return 'check_circle';
    }
    if (state === false) {
      return 'cancel';
    }
    return 'radio_button_unchecked';
  }

  toggle(field: 'atual' | 'nova' | 'repetir'): void {
    this.visible[field] = !this.visible[field];
  }

  clearMessage(): void {
    this.validationMessage = '';
  }

  cancel(): void {
    this.activeModal.dismiss();
  }

  confirmFromEnter(event: Event): void {
    event.preventDefault();
    this.confirm();
  }

  confirm(): void {
    const message = validatePasswordChange(
      this.senhaAtual.value,
      this.novaSenha.value,
      this.repetirSenha.value,
    );
    if (message) {
      this.validationMessage = message;
      return;
    }

    this.validationMessage = '';
    this.activeModal.close({
      senhaAtual: this.senhaAtual.value.trim(),
      novaSenha: this.novaSenha.value,
    } satisfies PasswordChangeResult);
  }
}
